import ApplicationView from './ApplicationView';
import { ResourceContainer } from 'ohzi-core';
import { CSSAnimator } from 'ohzi-core';
import { OS } from 'ohzi-core';

class HomeView extends ApplicationView
{
  constructor()
  {
    super();

    this.labs = {};
    // this.labs_hashtags = undefined;
  }

  start()
  {
    super.start('home', document.querySelector('.home'));

    // this.labs_hashtags = document.querySelectorAll('.lab__hashtags');

    // let video = document.querySelector('.video__ohzi');
    // let texture = new VideoTexture(video);

    // texture.minFilter = LinearFilter;
    // texture.magFilter = LinearFilter;
    // texture.format = RGBFormat;

    // this.floor = ResourceContainer.get_resource('floor').scene;
    // this.floor.scale.set(0.75, 1, 1);
    // this.floor_lights = ResourceContainer.get_resource('floor_lights').scene;
    // this.corridor.scale.set(0.1, 0.1, 0.1);

    // SceneManager.current.add(this.floor);
    // SceneManager.current.add(this.floor_lights);

    // Debug.draw_cube(new Vector3(0, 20, -50));

    this.init_labs();
    this.labs_keys = Object.keys(this.labs);
  }

  init_labs()
  {
    let labs = ResourceContainer.get_resource('labs');

    for (let i = 0; i < labs.length; i++)
    {
      // const lab = labs[i];

      let element = document.querySelector(`.lab.${labs[i].id}`);

      element.querySelector('.lab__description').addEventListener('wheel', function(ev)
      {
        ev.stopImmediatePropagation();
        ev.stopPropagation();
      });

      element.querySelector('.lab__description').addEventListener('touchstart', function(ev)
      {
        ev.stopImmediatePropagation();
        ev.stopPropagation();
      });

      let marquee_animator = this.__setup_marquee_animator(element);

      let opacity_animator = new CSSAnimator({
        element: element,
        css_property: 'opacity',
        duration: 0.3,
        finished_callback: this.on_opacity_animator_finished.bind(this)
      });

      let transform_animator = new CSSAnimator({
        element: element,
        css_property: 'transform',
        from: 0,
        to: 100,
        duration: 0.3,
        value_prefix: 'translate3d(',
        value_suffix: 'px,0px,0px)'
      });

      this.labs[labs[i].id] = {
        element: element,
        opacity_animator: opacity_animator,
        transform_animator: transform_animator,
        marquee_animator: marquee_animator
      };
    }
  }

  show_lab_info(wall)
  {
    this.labs[wall.id].opacity_animator.from = 0;
    this.labs[wall.id].opacity_animator.to = 1;
    this.labs[wall.id].opacity_animator.animate();

    this.labs[wall.id].transform_animator.from = 0;
    this.labs[wall.id].transform_animator.to = 0;
    this.labs[wall.id].transform_animator.animate();

    this.labs[wall.id].marquee_animator.animate();

    this.labs[wall.id].element.classList.remove('hidden');
  }

  hide_lab_info(wall)
  {
    this.labs[wall.id].opacity_animator.from = 1;
    this.labs[wall.id].opacity_animator.to = 0;
    this.labs[wall.id].opacity_animator.animate();

    this.labs[wall.id].transform_animator.from = 0;
    this.labs[wall.id].transform_animator.to = 50 * wall.dir;
    this.labs[wall.id].transform_animator.animate();

    this.labs[wall.id].marquee_animator.stop();
  }

  on_opacity_animator_finished(animator)
  {
    if (Number(animator.element.style.opacity) === 0)
    {
      animator.element.classList.add('hidden');
    }
  }

  on_marquee_animator_finished(animator)
  {
    let from = animator.from;
    let to = animator.to;

    animator.from = to;
    animator.to = from;

    animator.animate();
  }

  update()
  {
    for (let i = 0; i < this.labs_keys.length; i++)
    {
      this.labs[this.labs_keys[i]].opacity_animator.update();
      this.labs[this.labs_keys[i]].transform_animator.update();
      this.labs[this.labs_keys[i]].marquee_animator.update();
    }
  }

  __setup_marquee_animator(element)
  {
    let lab_hashtags = element.querySelector('.lab__hashtags');
    let marquee_inner = element.querySelector('.marquee__inner');
    let offset = 5;

    let marquee_difference = lab_hashtags.getBoundingClientRect().width - marquee_inner.getBoundingClientRect().width - offset;

    return new CSSAnimator({
      element: marquee_inner,
      css_property: 'transform',
      from: 5,
      to: marquee_difference,
      duration: OS.is_mobile ? 7 : 5,
      value_prefix: 'translate3d(',
      value_suffix: 'px,0px,0px)',
      easing_function: (t) =>
      {
        return t;
      },
      finished_callback: this.on_marquee_animator_finished.bind(this)
    });
  }
}

export default new HomeView();
